var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkflowManagementLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 195 195",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m114.48,44.77h38.64l16.45,16.45c.88.88,2.03,1.31,3.17,1.31s2.3-.44,3.17-1.31l17.77-17.77c1.75-1.75,1.75-4.6,0-6.35l-17.77-17.77c-1.75-1.75-4.59-1.75-6.35,0l-16.45,16.45h-38.64c-6.61,0-11.98,5.37-11.98,11.98v47.95h-34.84c-2.48,0-4.49,2.01-4.49,4.49s2.01,4.49,4.49,4.49h34.84v47.95c0,6.61,5.37,11.98,11.98,11.98h41.22v7.86c0,2.48,2.01,4.49,4.49,4.49h25.12c2.48,0,4.49-2.01,4.49-4.49v-25.12c0-2.48-2.01-4.49-4.49-4.49h-25.12c-2.48,0-4.49,2.01-4.49,4.49v8.29h-41.22c-1.66,0-3-1.35-3-3v-47.95h42.13c2.03,8.58,9.74,14.98,18.93,14.98,10.74,0,19.47-8.73,19.47-19.47s-8.73-19.47-19.47-19.47c-9.19,0-16.89,6.41-18.93,14.98h-42.13v-47.95c0-1.66,1.35-3,3-3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m37.41,92.16h-16.12c-11.74,0-21.28,9.55-21.28,21.28v41.21c0,2.48,2.01,4.49,4.49,4.49h49.72c2.48,0,4.49-2.01,4.49-4.49v-41.21c0-11.74-9.55-21.28-21.28-21.28Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.73,
    cy: 71.23,
    r: 16.15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkflowManagementLogo);
export default __webpack_public_path__ + "static/media/workflowManagementLogo.d515cc220a73b77b3bdf6be7458527a0.svg";
export { ForwardRef as ReactComponent };